import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "../../index.css";
import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Avatar, Box, Container } from "@mui/material";
import FlexBox from "components/common/FlexBox";
import Typography from "@mui/material/Typography";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import PrimaryButton from "components/common/PrimaryButton";
import { TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { chain, isEmpty, trim } from "lodash";
import * as actions from "actions";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { prop } from "ramda";
// import * as moment from 'moment';
import moment from "moment";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDateTimePicker from "@mui/lab/MobileDateTimePicker";
import Stack from "@mui/material/Stack";
import RemoveHolidayDialog from "./RemoveHolidayDialog";
import defaultValue from "assets/data/default-value";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.background.paper,
  },
  top: {
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    position: "relative",
    padding: theme.spacing(2),
  },
  bottomBox: {
    width: "100%",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  dateComp: {
    marginTop: 20,
    paddingBottom: 30,
  },
  fullWidth: {
    width: "100%",
  },
}));
export default function HolidayDetails({ Holiday = {} }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const defaultStartTime = moment().set("hour", "07").set("minute", "00");
  const defaultEndTime = moment().set("hour", "15").set("minute", "30");
  const [openRemoveHolidayDialog, setopenRemoveHolidayDialog] =
    React.useState(false);
  const holiday = Holiday || {};
  // const { userName = "", role = "", MobileNo = "", isNew = false,id=null } = user;
  const {
    StartDate = null,
    EndDate = null,
    Reason = "",
    isNew = false,
    Id = null,
  } = holiday;
  const [form, setForm] = useState({
    StartDate: Id ? StartDate : defaultStartTime,
    EndDate: Id ? EndDate : defaultEndTime,
    Reason: Reason,
    Id: Id,
  });
  const hasEmptyFields = isNew
    ? chain({
      ...form,
    })
      .omit(["Id"])
      .mapValues(trim)
      .some(isEmpty)
      .value()
    : chain({
      ...form,
    })
      .omit(["Id", "EndDate"])
      .mapValues(trim)
      .some(isEmpty)
      .value();
  const onAdd = () => {
    let body = { ...form };
    body.StartDate = body?.StartDate
      ? moment(body.StartDate).format(defaultValue.saveDateTimeFormat)
      : "";
    if (isNew) {
      body.EndDate = body?.EndDate
        ? moment(body.EndDate).format(defaultValue.saveDateTimeFormat)
        : "";
    } else {
      delete body.EndDate;
    }

    dispatch(actions.addHoliday(body));
  };

  const disabled = false;

  const updateField = (prop, value) => setForm({ ...form, [prop]: value });
  const handleChange = (prop) => (e) => {
    updateField(prop, e && e.target ? e.target.value : e);
  };

  const handleBlur = (prop) => (e) => updateField(prop, e.target.value.trim());

  const submitDisabled = hasEmptyFields;
  const onRemoveConfirm = () => {
    dispatch(actions.removeHoliday(form.Id));
  };
  const onRemove = () => {
    setopenRemoveHolidayDialog(true);
  };
  const closeDialog = () => {
    setopenRemoveHolidayDialog(false);
  };
  return (
    <>
      <Container className={classes.root}>
        <FlexBox className={classes.top}>
          <Box flexGrow={1} pl={2}>
            <Typography variant="h5">
              <strong data-testid="label-user-administration">
                {!isNew ? <>Edit Holiday</> : <>Add a holiday</>}
              </strong>
            </Typography>
          </Box>
        </FlexBox>

        <Container className={classes.container}>
          <ValidatorForm instantValidate={true} autoComplete="off">
            <TextValidator
autoComplete='new-password'
              name="Name"
              label="Holiday Name"
              value={form?.Reason}
              margin="normal"
              fullWidth
              disabled={disabled}
              data-testid="input-user-name"
              onChange={handleChange("Reason")}
              onBlur={handleBlur("Reason")}
              inputProps={{
                autoComplete: 'new-password', // disable autocomplete and autofill
              }}
            />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={3}>
                <MobileDateTimePicker
                  label="Start Date"
                  value={form?.StartDate}
                  onChange={handleChange("StartDate")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      margin="normal"
                      fullWidth
                    />
                  )}
                />
                {isNew ? (
                  <>
                    <MobileDateTimePicker
                      label="End Date"
                      value={form?.EndDate}
                      onChange={handleChange("EndDate")}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          margin="normal"
                          fullWidth
                        />
                      )}
                    />
                  </>
                ) : (
                  <></>
                )}
              </Stack>
            </LocalizationProvider>
          </ValidatorForm>
        </Container>
        <FlexBox justifyContent="center" flexDirection="column">
          {!isNew ? (
            <>
              <PrimaryButton
                onClick={onRemove}
                disabled={submitDisabled}
                data-testid="btn-remove-holiday"
                color="error"
              >
                Remove
              </PrimaryButton>
              <PrimaryButton
                onClick={onAdd}
                disabled={submitDisabled}
                data-testid="btn-remove-user"
              >
                Save
              </PrimaryButton>
            </>
          ) : (
            <>
              <PrimaryButton
                onClick={onAdd}
                data-testid="btn-add-user"
                disabled={submitDisabled}
              >
                Add Holiday
              </PrimaryButton>
            </>
          )}
        </FlexBox>
        <RemoveHolidayDialog
          open={openRemoveHolidayDialog}
          onClose={closeDialog}
          onRemoveConfirm={onRemoveConfirm}
        ></RemoveHolidayDialog>
      </Container>
      {/* <Container>
        <NavigationBar/>
      </Container> */}
    </>
  );
}
